import { Box, Heading, Stack, Text } from "@chakra-ui/react";
import NextImage from "next/image";

import Button from "components/Chakra/Button";
import IconLogoIdealninajemce from "components/Chakra/Icons/LogoIdealninajemce";
import IconLogoUlovdomov from "components/Chakra/Icons/LogoUlovdomov";
import { labels } from "./translation";

type HeaderProps = {
  handleScrollToSection: () => void;
};

const Header = ({ handleScrollToSection }: HeaderProps) => (
  <Stack direction={{ base: "column", xl: "row" }} gap="20px">
    <Stack maxW={{ xl: "550px" }} pt={{ base: "48px", md: "70px" }}>
      <Box>
        <IconLogoIdealninajemce
          id="LogoIdealninajemce"
          h={{ base: "50px", md: "90px" }}
          w="auto"
          fillWith="ud-primary"
          _groupHover={{ fill: "ud-primary-400" }}
        />
      </Box>
      <Text
        position="relative"
        left={{ base: "15%", md: "30%" }}
        fontWeight="bold"
        color="ud-black"
        fontSize={{ base: "14px", md: "22px" }}
      >
        Premiová služba od
        <IconLogoUlovdomov
          mt="-10px"
          w={["96px", "120px"]}
          h="100%"
          fill="ud-primary"
          ml="10px"
        />
      </Text>
      <Heading pt="60px">Pronájem bez starostí a bez rizika</Heading>
      <Text pb="20px">
        Váš byt si pronajmeme a postaráme se o vše potřebné. Garantujeme vám
        <Text as="span" fontWeight="700" color="ud-black">
          {" "}
          stav bytu, pravidelný příjem i kvalitní podnájemníky.
        </Text>
      </Text>
      <Stack align={{ base: "center", xl: "flex-start" }}>
        <Button
          width="fit-content"
          borderRadius="full"
          onClick={handleScrollToSection}
        >
          Chci zjistit více
        </Button>
      </Stack>

      <Stack
        direction={{ base: "column", md: "row" }}
        gap="40px"
        pt="40px"
        justify={{ base: "center", xl: "flex-start" }}
      >
        {labels.map((item, index) => (
          <Stack key={index} direction="column">
            <Text color="ud-primary" fontSize="25px" fontWeight="700">
              {item.counter}
            </Text>
            <Text>{item.description}</Text>
          </Stack>
        ))}
      </Stack>
    </Stack>
    <Stack
      w="100%"
      position="relative"
      justify="center"
      align="center"
      display={{ base: "none", md: "flex" }}
    >
      <NextImage
        src="/idealni-najemce-lp/img/6428425-p-1600.jpg"
        alt="Idealni najemce"
        width={600}
        height={550}
        style={{ objectFit: "cover" }}
      />
    </Stack>
  </Stack>
);
export default Header;
